import { Group, Stack, Text } from '@mantine/core';
import DataTables from 'components/DataTables';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { VersionData } from 'types/lcms/courses';

interface VersionHistoryProps {
  data?: VersionData[];
}

const VersionHistory: React.FC<VersionHistoryProps> = ({ data }) => {
  return (
    <Stack gap={16}>
      <Group gap={8}>
        <HiOutlineDocumentText />
        <Text c={'dark'} fw={700}>
          Version History
        </Text>
      </Group>

      <DataTables
        columns={[
          {
            heading: 'Version',
            props: 'history',
            sortable: true,
            active: true,
            id: 'history'
          },
          {
            heading: 'Reason',
            props: 'reason',
            sortable: true,
            active: true,
            id: 'reason'
          },
          {
            heading: 'Status',
            props: 'status',
            sortable: true,
            active: true,
            id: 'status'
          }
        ]}
        data={data ?? []}
        emptyMessage='No version history available'
        withPagination={false}
      />
    </Stack>
  );
};

export default VersionHistory;
